<div class="timeline-date-box" data-cy="timeline-date-box">
  <p class="date" data-cy="timeline-date">{{ time | dayJapanesesText }}</p>
  <div class="list-action" [class.delete-border-bottom]="nextActionDate">
    @for (action of actions; track action; let last = $last) {
      <app-action-item [action]="action" [isLast]="last && !isLoadMoreInnerBox"></app-action-item>
    }
  </div>

  @if (nextActionDate) {
    <div class="load-more" [ngClass]="isLoadMoreInnerBox ? 'load-more-inner-box' : 'load-more-outer-box'">
      <a class="spen-util-link" (click)="onLoadMore()">
        もっと見る<i [class]="actionsLoading ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
      </a>
    </div>
  }
</div>
